
<!--<app-alerts></app-alerts>-->
<main>
  <div class="h-100">
    <section>
      <div class="container-fluid ptb-42">
        <div class="row">
          <div class="col-auto">
            <div class="titles-bdr-r">
              <h1 class="color-primary fs-325remTitles">{{faresInfo.Titulo_Pagina}}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container pb-120 gx-5 gx-lg-0 tab-style4">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-3 col-xxl-3 pe-lg-0 px-2 mt-5">
            <!-- start tab navigation -->
            <ul class="nav nav-tabs sticky-lg-top">
              <li *ngFor="let tarifario of faresList; let i = index;" class="nav-item color-black">
                <a id="tab-{{tarifario.Tipo_Tarifario | slugify}}" class="nav-link" [ngClass]="{active: i == 0}"
                   href="#tabcontent-{{i}}" data-bs-toggle="tab">{{ tarifario.Tipo_Tarifario }}</a>
              </li>
            </ul>
            <!-- end tab navigation -->
          </div>
          <div class="col-12 col-lg-9 col-xxl-7 ps-lg-0 px-2">
            <div class="tab-content">
              <!-- start tab content -->
              <div *ngFor="let tarifario of faresList; let i = index;"
                   class="tab-pane" [ngClass]="{active: i == 0}" [id]="'tabcontent-' + i">
                <div class="row justify-content-center d-flex accordion custom-accordionPlus">
                  <div class="col-12 custom-accordionPlusPrices p-top-tabs-content">
                    <div class="col-12 align-self-center">
                      <div *ngFor="let item of tarifario.Tarifarios; let j=index;" class="accordion-item">
                        <h2 class="accordion-header" [id]="'questao-' + i + '-' + j">
                          <button class="accordion-button collapsed d-flex justify-content-between" type="button" aria-expanded="false" data-bs-toggle="collapse"
                                  [attr.data-bs-target]="'#resposta-' + i + '-' + j" [attr.aria-controls]="'resposta-' + i + '-' + j">
                            {{item.Nome}}<span *ngIf="item.Preco != null" class="spanPriceTarifarios">{{item.Preco}}€</span>
                          </button>
                        </h2>
                        <div [id]="'resposta-' + i + '-' + j" class="accordion-collapse collapse"
                             [attr.data-bs-parent]="'#tabcontent-' + i">
                          <div class="accordion-body">
                            <p class="mt-3" [innerHTML]="item.Descricao"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="tarifario.Precos.length > 0" class="col-12 p-top-tabs-content">
                    <table class="table table-striped">
                      <thead class="thead-dark">
                      <tr>
                        <th scope="col" class="text-center align-middle fsTrResponsivePriceTable">{{'tarifarios.numZonas' | translate}}</th>
                        <th scope="col" class="text-center align-middle fsTrResponsivePriceTable">{{'tarifarios.bilheteBordo' | translate}}</th>
                        <th scope="col" class="text-center align-middle fsTrResponsivePriceTable">{{'tarifarios.meioBilhete' | translate}}</th>
                        <th scope="col" class="text-center align-middle fsTrResponsivePriceTable">{{'tarifarios.preComprado' | translate}}</th>
                        <th scope="col" class="text-center align-middle fsTrResponsivePriceTable">{{'tarifarios.bilhete24h' | translate}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let linhaPrecos of tarifario.Precos">
                        <th scope="row" class="text-center align-middle fsResponsivePriceTable">{{linhaPrecos.Num_Zonas}}</th>
                        <td class="text-center align-middle fsResponsivePriceTable">
                          <span *ngIf="linhaPrecos.Mostrar_Sinal_Mais">+</span>
                          {{linhaPrecos.Bilhete_Bordo | number:'1.2-2' }}€
                        </td>
                        <td class="text-center align-middle fsResponsivePriceTable">
                          <span *ngIf="linhaPrecos.Mostrar_Sinal_Mais">+</span>
                          {{linhaPrecos.Meio_Bilhete | number:'1.2-2' }}€
                        </td>
                        <td class="text-center align-middle fsResponsivePriceTable">
                          <span *ngIf="linhaPrecos.Mostrar_Sinal_Mais">+</span>
                          {{linhaPrecos.Pre_Comprado | number:'1.2-2' }}€
                        </td>
                        <td class="text-center align-middle fsResponsivePriceTable">
                          <span *ngIf="linhaPrecos.Mostrar_Sinal_Mais">+</span>
                          {{linhaPrecos.Bilhete_24h | number:'1.2-2' }}€
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 mt-5">
                    <p [innerHTML]="tarifario.Texto_Tipo_Tarifario"></p>
                  </div>
                </div>
              </div>
              <!-- end tab content -->
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-40">
          <div class="col-12 col-lg-3"></div>
          <div class="col-12 col-lg-7 ps-custom-collumn7">
            <p [innerHTML]="faresInfo.Texto_Rodape"></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>

